// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"180":"984c1fff18c533e9","254":"2deb315b6202f616","376":"50c756a74ca94a75","390":"b4b1f9958d17dced","514":"06767553881965ad","689":"1be3b91e9084dd8d","873":"2547d88ad80ba65c"}[chunkId] + ".js";
};